module.exports = __webpack_public_path__ + "img/애고미_이모티콘-32.ec46d21.png";